import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useNavigate, useParams } from "react-router-dom";
import { createPageData, projectFormData } from "./ProjectFile";
import { dropdownData, getRecords } from "../../services/api.service";
import { LoaderCreatePage } from "../Loader/Loader";
import "../../Style/style.css";
import UserDetailsModal from "../../components/CommonForBoth/TopbarDropdown/UserProfile/UserDetailModel";

const ProjectView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(projectFormData());
  const [customerSelect, setCustomerSelect] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const [isCustomerModelOpen, setIsCustomerModelOpen] = useState(false);
  const [companyName, setCompanyName] = useState(false);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        getUserMasterDropData(data?.customer_id);
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getUserMasterDropData = async (customerId) => {
    try {
      let payload = {
        modelName: "company_masters",
        whereCondition: {
          id: customerId,
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/listCustomers");
      if (responseData.data && responseData.data.length > 0) {
        setCompanyName(responseData?.data[0]?.company_name);
      }
      setLoadingData(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Project Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}>
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3">
                              <p>
                                <strong>Project Code: </strong>
                                {formData?.inputData?.project_code || "-"}
                              </p>
                              <p>
                                <strong>Project Name: </strong>
                                {formData?.inputData?.project_name || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Customer: </strong>
                                <span
                                  className="text-primary cursor-pointer"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setIsCustomerModelOpen(true)}>
                                  {companyName || "-"}
                                </span>
                              </p>
                              {isCustomerModelOpen && (
                                <UserDetailsModal
                                  onClose={() => setIsCustomerModelOpen(false)}
                                  id={formData?.inputData?.customer_id}
                                  type="customer"
                                />
                              )}
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active == true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="contact-details-card p-3">
                          <h6 className="h-6-heading">
                            Contact Person Details
                          </h6>
                          {/* Card Grid Layout for Contact Person Details */}
                          <div className="row mt-2">
                            {formData?.inputData?.contact_person_details
                              ?.length > 0 ? (
                              formData.inputData.contact_person_details.map(
                                (item, index) => (
                                  <div
                                    key={index}
                                    className="col-md-6 col-lg-3">
                                    <div
                                      className="card"
                                      style={{
                                        marginBottom: "20px",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                        overflow: "hidden",
                                        transition:
                                          "transform 0.3s ease, box-shadow 0.3s ease",
                                      }}
                                      onMouseOver={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1.05)";
                                        e.currentTarget.style.boxShadow =
                                          "0 4px 10px rgba(0, 0, 0, 0.1)";
                                      }}
                                      onMouseOut={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1)";
                                        e.currentTarget.style.boxShadow =
                                          "none";
                                      }}>
                                      <div
                                        className="card-body"
                                        style={{
                                          padding: "16px",
                                          backgroundColor: "#f9f9f9",
                                        }}>
                                        <h5
                                          className="card-title"
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            color: "#343a40",
                                            marginBottom: "12px",
                                          }}>
                                          {item.contact_person_name ||
                                            "Not Specified"}
                                        </h5>
                                        <p
                                          style={{
                                            marginBottom: "8px",
                                            color: "#495057",
                                          }}>
                                          <strong>Email:</strong>{" "}
                                          {item.contact_person_email ||
                                            "Not Specified"}
                                        </p>
                                        <p style={{ color: "#495057" }}>
                                          <strong>Mobile:</strong>{" "}
                                          {item.contact_person_mobile ||
                                            "Not Specified"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    color: "#6c757d",
                                  }}>
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Row>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectView;
